function SavedCardService(Restangular) {
    this._api = Restangular.all('SavedCards');
    this._deleteCardApi = Restangular.all('/SavedCards/DeleteSavedCards');
    this.cardList = [];
}
SavedCardService.prototype.getSavedCard = function () {
    return this._api.get();
};

SavedCardService.prototype.getSavedCards = function () {
    const self = this;
    return this._api.getList()
        .then((cards) => {
            self.cardList = cards && cards.rawResponse
                ? cards.rawResponse
                : [];
            return self.cardList;
        });
};

SavedCardService.prototype.invalidateSavedCardCache = function () {
    this.cardList.length = 0;
};

SavedCardService.prototype.deleteSavedCard = function (pan) {
    return this._deleteCardApi.post({ Pan: pan });
};

SavedCardService.prototype.saveCardForOrder = function (orderId) {
    return this._api.post({ OrderId: orderId });
};

module.exports = SavedCardService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/savedcard/saved-card-service.js
 **/